import { useMemo } from 'react';
import { readModules } from "v4/features/front/pennylane/pennylane.utils";

export default function usePennylaneState(quote) {
    const modules = quote?.metadata?.modules;

    return useMemo(() => {
        const pennylane = readModules(modules)?.pennylane;

        if (!pennylane) {
            return { isActive: false };
        }

        return {
            isActive: true,
            hasExternalRelation: pennylane.quote?.url != null,
            hasLinkedInvoice: pennylane.invoice?.url != null,
            isLocked: pennylane.display?.isLocked === true,
            lockReason: pennylane.display?.lockReason ?? null,
            quoteUrl: pennylane.quote?.url ?? null,
            invoiceUrl: pennylane.invoice?.url ?? null,
        };
    }, [modules]);
}
